let load = require('./helpers/browser/esm-js-loader');
module.exports = (load("jb2st")).then(() => parcelRequire('7w5dx'));